﻿export class Usuario {
    idUsuario: number;
    nombreUsuario: string;
    contrasena: string;
    confirmacionContrasena: string;
    correo: string;
    tipoUsuario: string;
    idCorporativo: number;
    idProveedor: number;
}